export const SWAP_SETTINGS_KEYS = {
  SLIPPAGE: 'swapSettings.slippage',
  TX_DEADLINE: 'swapSettings.txDeadline',
};

export const ADD_LIQUIDITY_SETTINGS_KEYS = {
  TX_DEADLINE: 'addLiquiditySettings.txDeadline',
};

export const GLOBAL_SETTINGS_KEYS = 'userSettings';
